export default function slugify(name) {
    return name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '');

}
